import { type FC } from 'react';
import { Image, VStack } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { Drawer, DrawerHeader, type DrawerProps } from '../Drawer';
import styles from './SizeTable.module.css';

interface SizeTableProps extends Pick<DrawerProps, 'isOpen' | 'onClose'>, TestProps {
    sizeTableSrc: string;
}

export const SizeTable: FC<SizeTableProps> = ({
    'data-testid': dataTestId = 'SizeTable',
    sizeTableSrc,
    isOpen,
    onClose,
}) => (
    <>
        <Drawer data-testid={dataTestId} size="auto" isOpen={isOpen} onClose={onClose}>
            <VStack className={styles.wrapper}>
                <DrawerHeader data-testid={`${dataTestId}.Header`} className={styles.title} title="Таблица размеров" />

                <div className={styles.sizeTable}>
                    <Image
                        width="100%"
                        height="100%"
                        alt="Таблица размеров"
                        src={sizeTableSrc}
                        className={styles.image}
                        fit="contain"
                    />
                </div>
            </VStack>
        </Drawer>
    </>
);
